import { Close, VFlex, VStack } from '@/package';
import { useFrameImageViewer } from '@/provider';
import { useTaskFrameStore, useToolMenuStore } from '@/store';

import { useToolPlayControllerContext } from '../ToolPlayController';
import { ToolImagePopupImageItem } from './ToolImagePopupImageItem';

export const ToolImagePopup = () => {
  const { currentFrame } = useTaskFrameStore();
  const { deselect, findByName } = useToolMenuStore();
  const { openImagePopupInNewWindow } = useFrameImageViewer();
  const imageList = currentFrame?.imagePath ?? [];
  const { $toolPlayController } = useToolPlayControllerContext();

  const onFullScreenClick = (index: number) => {
    openImagePopupInNewWindow(index);
    deselect(findByName('frameCamImage')!.id);
  };

  return (
    <VStack
      className="pointer-events-none absolute top-0 left-0 w-[314px] bg-transparent"
      justify="end"
      style={{
        bottom: `${$toolPlayController.current?.offsetHeight}px`,
      }}
    >
      <VStack className="pointer-events-auto h-fit max-h-full gap-1 rounded-r-sm bg-white px-1">
        <VFlex items="center" justify="between" className="px-2 py-1">
          <VFlex items="center" gap={0.25}>
            <div className="text-body-lg font-bold text-blue-300">
              Frame image
            </div>
          </VFlex>

          <VFlex items="center" gap={0.25}>
            <span className="text-body-sm text-gray-400">Total</span>
            <span className="text-body-sm text-gray-500">
              {imageList.length}
            </span>
            <Close
              className="size-4 text-gray-400"
              role="button"
              onClick={() => {
                deselect(findByName('frameCamImage')!.id);
              }}
            />
          </VFlex>
        </VFlex>

        <VStack
          gap={0.25}
          className="w-full flex-1 overflow-x-hidden overflow-y-auto"
        >
          {imageList.map((imagePath, index) => (
            <ToolImagePopupImageItem
              key={imagePath}
              index={index}
              onFullScreenClick={onFullScreenClick}
            />
          ))}
        </VStack>
      </VStack>
    </VStack>
  );
};
